// removed by extract-text-webpack-plugin
module.exports = {"page":"LoginPage__page___QAFRC","graphic":"LoginPage__graphic___1HdCe","lettering":"LoginPage__lettering___2ZaUj","error":"LoginPage__error___2lsew","link":"LoginPage__link___2n_LP","forgotPasswordLink":"LoginPage__forgotPasswordLink___ThGi2","title":"LoginPage__title___3iXHf"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/pages/LoginPage.css
// module id = 145
// module chunks = 0